import React, { memo, useEffect, useState } from 'react'

import { BellOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import {
  Avatar,
  Badge,
  Col,
  Divider,
  Drawer,
  Form,
  Layout,
  Menu,
  message,
  Popover,
  Row,
  Select,
  Space,
  Spin,
  Timeline,
  Tooltip,
} from 'antd'
import { Link, useHistory } from 'react-router-dom'

import { faCogs, faPowerOff } from '@fortawesome/free-solid-svg-icons'
import { useLoadScript } from '@react-google-maps/api'

import Container from './styled'

import LogoSM from '../../assets/img/logo-sm.png'
import Logo from '../../assets/img/logo.png'
import LogoTest from '../../assets/img/teste_logo.png'
import LogoSMTest from '../../assets/img/teste_logo_sm.png'
import { APP_PREFIX_PATH } from '../../Configs/AppConfig'
import { localConfig } from '../../Configs/localConfig'
import { useAccess } from '../../context/useAccess'
import { useLogic } from '../../context/useLogic'
import { getClimaCodCity } from '../../services/apiClima'
import { getCliente, getConsultoria } from '../../services/Cliente'
import { getSafra, getSafraEstatisticas } from '../../services/Safra'
import { AppViews } from '../../Views/app'

import DropUser from '../dropUser'

import dayjs from 'dayjs'
import { orderBy } from 'lodash'
import version from '../../assets/data/version.json'
import Icons from '../Icons'

const { Header, Sider, Content } = Layout

const { SubMenu } = Menu
const { Option, OptGroup } = Select

const MenuLyout: React.FC = () => {
  const {
    itens,
    setResponsive,
    responsive,
    setTypeAccess,
    setLisSafra,
    setCodCliente,
    dataConta,
    lisSafra,
    dataCliente,
    setDataCliente,
    safraSelecionada,
    setSafraSelecionada,
    rota,
    setDataClima,
    setLocation,
  } = useLogic()

  const { navigate, loading, setLoggedInAs, setNameCliente, setNameSafra, setCodCultura } =
    useAccess()

  const history = useHistory()

  const [collapsed, setCollapsed] = useState(false)
  const [collapsedWidth, setCollapsedWidth] = useState(80)
  const [clienteSelecionado, setClienteSelecionado] = useState('')

  const [consultoria, setConsultoria] = useState([])
  const [menuSelect, setMenuSelect] = useState([])

  const [openKeys, setOpenKeys] = useState([])

  const [versionDrawer, setVersionDrawer] = useState(false)

  const [loadingMenu, setLoadingMenu] = useState(false)
  const [loadingSafra, setLoadingSafra] = useState(false)
  const [dadosEstatisticas, setDadosEstatisticas] = useState([])
  const [showDetalhes, setShowDetalhes] = useState(false)

  const toggle = (e) => {
    if (e.preventDefault) {
      e.preventDefault()
    }
    setCollapsed(!collapsed)
  }

  const [form] = Form.useForm()

  const handleRefresh = async (data, event) => {
    message.loading('Carregando Aguarde ...')
    setNameCliente(event.data.name)

    if (event.data.type === 'CLIENTE' || event.data.type !== 'CONTA') {
      localStorage.setItem('cod-cliente', data)
      setLoggedInAs({
        type: 'CONTA_CLIENTE',
        codCliente: data,
        codConta: Number(localStorage.getItem('conta')),
      })
    } else {
      localStorage.setItem('cod-cliente', '')
      setLoggedInAs({
        type: 'CONTA',
        codCliente: null,
        codConta: event.data.value,
      })
    }
    const climaType: any = event.data.type === 'CONTA_CLIENTE' ? 1 : 0
    handleClima(data, climaType ? 1 : 0)

    localStorage.setItem('cod-cliente', data)

    form.setFieldsValue({ safra: null })
    localStorage.removeItem('codSafra')
    setDadosEstatisticas([])

    setClienteSelecionado(data)
    listSafras()

    history.push('/home')
    setMenuSelect(['/home'])

    setCodCliente(data)

    message.destroy()
  }

  const handleSafraSelected = (data, element: any = {}) => {
    setNameSafra(element.children)
    form.setFieldsValue({ safra: data })
    localStorage.setItem('codSafra', data)
    listTotalPropriedade(data)

    setSafraSelecionada(data)

    const codCultura = lisSafra.find((rec) => rec.cod === data)?.cod_cultura
    localStorage.setItem('codCultura', JSON.stringify(codCultura))

    setCodCultura(codCultura)
    if (rota !== '/talhao/safra') {
      if (rota === null) {
        history.push('/home')
      } else {
        history.push(rota)
      }
    }
  }

  const handleClima = async (cod, tipo) => {
    let response
    let city

    if (tipo === 1) {
      response = await getCliente(cod, '', '')
      city = response.data.itens[0].cidade
    } else {
      response = await getConsultoria()
      city = response.data.itens[0].cidade[0]
    }
    const clima = await getClimaCodCity({
      q: { city: city.nome, uf: city.uf_sigla },
    })

    // @ts-ignore
    clima.data.city.uf = city.uf_sigla

    setDataClima(clima.data)
  }

  const listSafras = async () => {
    setLoadingSafra(true)
    setLisSafra([])

    const response = await getSafra({ order: 'data_inicio' })
    const dataSafra = response.data.itens

    setLisSafra(
      orderBy(
        dataSafra,
        (rec) => {
          return dayjs(rec.data_final).unix()
        },
        'desc'
      )
    )
    setLoadingSafra(false)
  }

  const listTotalPropriedade = async (cod) => {
    const response = await getSafraEstatisticas()
    const filter = response.data.itens.filter((item) => item.cod === cod)
    const validar = filter?.[0].total_propriedades > 0 ? true : false
    setShowDetalhes(validar)
    setDadosEstatisticas(filter)
  }

  const onOpenChange = (keys) => {
    setOpenKeys([keys[keys.length - 1]])
  }

  const loadScriptGoogleMaps = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_TOKEN_GOOGLE_MAPS,
    libraries: ['places', 'drawing', 'visualization', 'geometry'],
    language: 'pt-BR',
  })

  const selectClient = (
    <Col className='selectCliente' span={24} style={{ backgroundColor: '#fff' }}>
      <Row>
        <Form
          form={form}
          layout='inline'
          style={
            responsive
              ? {
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '10px',
                  marginLeft: '5px',
                  width: '240px',
                  height: '120px',
                  flexDirection: 'column',
                }
              : {}
          }
        >
          {localStorage.getItem('tipo-acesso') === 'cliente' ? (
            <h3 style={{ display: 'inline', marginTop: '9px' }}>
              {localStorage.getItem('nome-cliente')}
            </h3>
          ) : null}
          <Space wrap>
            <Form.Item style={{ height: '60px' }}>
              <Select
                onChange={handleRefresh}
                value={clienteSelecionado}
                optionFilterProp='children'
                popupMatchSelectWidth={500}
                showSearch
                style={{
                  minWidth: '20vw',
                  width: '240px',
                  // @ts-ignore
                  display:
                    localStorage.getItem('tipo-acesso') === 'cliente' ||
                    itens[0]?.acessoConta.contas.length <= 0
                      ? 'none'
                      : 'block',
                }}
                size='large'
              >
                <OptGroup label='Clientes'>
                  {dataCliente.map((data) => {
                    return (
                      <Option
                        key={data.cod}
                        value={data.cod}
                        data={{ type: 'CONTA_CLIENTE', name: data.nome, value: data.cod }}
                      >
                        <Avatar size='default' src={data.logo} />
                        <Divider type='vertical' /> {data.nome}
                      </Option>
                    )
                  })}
                </OptGroup>
                <OptGroup label='Consultoria'>
                  {consultoria.map((data) => (
                    <Option
                      ref='conta'
                      value=''
                      key='conta'
                      data={{ type: 'CONTA', name: data.nome, value: data.cod }}
                    >
                      <Avatar size='default' />
                      <Divider type='vertical' /> {data.nome}
                    </Option>
                  ))}
                </OptGroup>
              </Select>
            </Form.Item>
            {/* <Form.Item hidden={itens[0]?.acessoConta.contas.length <= 0} name='safra'> */}
            <div>
              <Form.Item name='safra'>
                <Select
                  onChange={handleSafraSelected}
                  value={safraSelecionada}
                  loading={loadingSafra}
                  optionFilterProp='filter'
                  popupMatchSelectWidth={false}
                  showSearch
                  size='large'
                  style={{
                    minWidth: '150px',
                    width: responsive && '240px',
                  }}
                  placeholder='Safra'
                  options={lisSafra.map((rec) => {
                    return {
                      key: rec.cod,
                      value: rec.cod,
                      label: (
                        <>
                          <div>{rec.nome}</div>
                          <small style={{ color: '#ccc', fontSize: '10px' }}>
                            Vigência {dayjs(rec.data_final).format('DD/MM/YYYY')}
                          </small>
                        </>
                      ),
                      filter: rec.nome,
                    }
                  })}
                />
              </Form.Item>

              <div style={{ width: '90%', height: '20px' }}>
                {showDetalhes === true ? (
                  <>
                    {dadosEstatisticas.map((item) => {
                      return (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            color: '#a3a3a3',
                            fontSize: '12px',
                          }}
                        >
                          <p style={{ fontSize: '11px', marginTop: '2px' }}>
                            Talhões: {item.total_talhoes}
                          </p>
                          <p style={{ fontSize: '11px', marginTop: '2px' }}>
                            Área: {item.total_area_talhoes} ha
                          </p>
                        </div>
                      )
                    })}
                  </>
                ) : null}
              </div>
            </div>

            {/* <Form.Item >
              
            </Form.Item> */}
          </Space>
        </Form>
      </Row>
    </Col>
  )

  useEffect(() => {
    if (safraSelecionada !== null) {
      const nameSafra = lisSafra.find((rec) => rec.cod === safraSelecionada)?.nome
      handleSafraSelected(safraSelecionada, { children: nameSafra })
    }
  }, [safraSelecionada])

  useEffect(() => {
    const fetch = async () => {
      setLoadingMenu(true)
      const config = localConfig()

      setTypeAccess(config.acesso)

      if (config.conta !== null) {
        const dados = itens[0]?.acessoConta?.contas.find(
          (data) => data.cod === Number(config.conta)
        )
        setDataCliente(dados?.clientes === undefined ? [] : dados?.clientes)
      }

      setConsultoria(dataConta)
      listSafras()

      handleClima(
        config.tipo === 'conta' ? config.conta : config.codCliente,
        config.tipo === 'conta' ? 0 : 1
      )
      setLoadingMenu(false)
    }

    const link = window.location
    setLocation(link)

    fetch()
  }, [])

  return (
    <Container collapsed={collapsed}>
      {!loadScriptGoogleMaps.isLoaded ? (
        <div className='loader'>
          <div className='logo-loader'>
            <img width='100' src={LogoSM} alt='Logo' />
            <br />
            <Spin size='large' />
          </div>
        </div>
      ) : (
        <Layout>
          <div className='area-menu'>
            {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'trigger-responsive',
              hidden: !responsive,
              onClick: toggle,
            })}
            <Sider
              style={{
                // overflow: 'auto',
                height: '100%',
                left: 0,
              }}
              className='corThema'
              theme='dark'
              trigger={null}
              collapsible
              collapsed={collapsed}
              width='250'
              breakpoint='md'
              collapsedWidth={collapsedWidth}
              onBreakpoint={(broken) => {
                setResponsive(!!broken)
                return broken ? setCollapsedWidth(0) : setCollapsedWidth(80)
              }}
              onCollapse={(collapsed2, type) => {
                return collapsed2 ? setCollapsed(true) : setCollapsed(false)
              }}
            >
              <div className='area-logo'>
                {window.location.origin === 'https://test.ttivos.app' ||
                window.location.origin === 'http://localhost:3000' ? (
                  <img
                    className={collapsed ? 'logo-sm-test' : 'logo-test'}
                    src={collapsed ? LogoSMTest : LogoTest}
                    alt=''
                  />
                ) : (
                  <img
                    className={collapsed ? 'logo-sm' : 'logo'}
                    src={collapsed ? LogoSM : Logo}
                    alt=''
                  />
                )}
              </div>
              {loadingMenu ? (
                <div
                  style={{
                    position: 'absolute',
                    width: '100%',
                    paddingLeft: '38%',
                    paddingTop: '20%',
                  }}
                >
                  <Spin className='loadingMenu' size='large' />
                </div>
              ) : (
                <Menu
                  className='corThema'
                  style={{ minHeight: 'calc(100% - 290px)' }}
                  theme='dark'
                  mode='inline'
                  defaultSelectedKeys={['1']}
                  onClick={(data) => setMenuSelect([data.key])}
                  selectedKeys={menuSelect}
                  onOpenChange={onOpenChange}
                  openKeys={openKeys}
                >
                  {responsive && selectClient}

                  {loading ? (
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Spin size='large' />
                    </div>
                  ) : (
                    navigate.map((menu) =>
                      menu.submenu.length > 0 ? (
                        <SubMenu
                          className='title'
                          style={{ display: menu.hidden ? 'none' : '' }}
                          icon={menu.icon ? <Icons icon={menu.icon} /> : null}
                          onTitleClick={() => (menu.path ? history.push(menu.path) : null)}
                          key={menu.key}
                          title={menu.title}
                        >
                          {menu.submenu.map((subMenuFirst) => {
                            return subMenuFirst.submenu.length > 0 ? (
                              <SubMenu
                                style={{
                                  display: subMenuFirst.hidden ? 'none' : '',
                                }}
                                icon={
                                  subMenuFirst.icon ? <Icons icon={subMenuFirst?.icon} /> : null
                                }
                                onTitleClick={() => history.push(subMenuFirst.path)}
                                key={subMenuFirst.key}
                                title={subMenuFirst.title}
                              >
                                {subMenuFirst.submenu.map((subMenuSecond) =>
                                  subMenuSecond.submenu.length > 0 ? (
                                    <SubMenu
                                      style={{
                                        display: subMenuSecond.hidden ? 'none' : '',
                                      }}
                                      icon={
                                        subMenuSecond.icon ? (
                                          <Icons icon={subMenuSecond?.icon} />
                                        ) : null
                                      }
                                      key={subMenuSecond.key}
                                      title={subMenuSecond.title}
                                    >
                                      {subMenuSecond.submenu.map((subMenuTree) =>
                                        subMenuTree.submenu.length > 0 ? (
                                          <SubMenu
                                            style={{
                                              display: subMenuTree.hidden ? 'none' : '',
                                            }}
                                            icon={
                                              subMenuTree.icon ? (
                                                <Icons icon={subMenuTree?.icon} />
                                              ) : null
                                            }
                                            key={subMenuTree.key}
                                            title={subMenuSecond.title}
                                          >
                                            {subMenuTree.submenu.map((subMenuFor) =>
                                              subMenuFor.submenu.length > 0 ? (
                                                <SubMenu
                                                  style={{
                                                    display: subMenuFor.hidden ? 'none' : '',
                                                  }}
                                                  icon={
                                                    subMenuFor.icon ? (
                                                      <Icons icon={subMenuFor?.icon} />
                                                    ) : null
                                                  }
                                                  key={subMenuFor.key}
                                                  title={subMenuFor.title}
                                                />
                                              ) : (
                                                <Menu.Item
                                                  onClick={responsive ? toggle : null}
                                                  key={subMenuFor.key}
                                                  icon={
                                                    subMenuFor.icon ? (
                                                      <Icons icon={subMenuFor?.icon} />
                                                    ) : null
                                                  }
                                                >
                                                  <span>{subMenuFor.title}</span>
                                                  <Link to={subMenuFor.path} />
                                                </Menu.Item>
                                              )
                                            )}
                                          </SubMenu>
                                        ) : (
                                          <Menu.Item
                                            onClick={responsive ? toggle : null}
                                            key={subMenuTree.key}
                                            icon={
                                              subMenuTree.icon ? (
                                                <Icons icon={subMenuTree?.icon} />
                                              ) : null
                                            }
                                          >
                                            <span>{subMenuTree.title}</span>
                                            <Link to={subMenuTree.path} />
                                          </Menu.Item>
                                        )
                                      )}
                                    </SubMenu>
                                  ) : (
                                    <Menu.Item
                                      onClick={responsive ? toggle : null}
                                      key={subMenuSecond.key}
                                      icon={
                                        subMenuSecond.icon ? (
                                          <Icons icon={subMenuSecond?.icon} />
                                        ) : null
                                      }
                                    >
                                      <span>{subMenuSecond.title}</span>
                                      <Link to={subMenuSecond.path} />
                                    </Menu.Item>
                                  )
                                )}
                              </SubMenu>
                            ) : (
                              <Menu.Item
                                onClick={responsive ? toggle : null}
                                key={subMenuFirst.key}
                                hidden={subMenuFirst.hidden}
                                icon={
                                  subMenuFirst.icon ? (
                                    <Tooltip
                                      trigger='hover'
                                      placement='right'
                                      title={
                                        subMenuFirst.title.length >= 27 ? subMenuFirst.title : null
                                      }
                                    >
                                      <Icons icon={subMenuFirst.icon} />
                                    </Tooltip>
                                  ) : null
                                }
                              >
                                <span>{subMenuFirst.title}</span>

                                <Link to={subMenuFirst.path} />
                              </Menu.Item>
                            )
                          })}
                        </SubMenu>
                      ) : (
                        <Menu.Item
                          onClick={responsive ? toggle : null}
                          hidden={menu.hidden}
                          key={menu.key}
                          icon={menu.icon ? <Icons icon={menu?.icon} /> : null}
                        >
                          <span>{menu?.title}</span>
                          {menu.path ? <Link to={menu.path} /> : null}
                        </Menu.Item>
                      )
                    )
                  )}
                  {!loading ? (
                    <>
                      <Menu.Item
                        onClick={responsive ? toggle : null}
                        key='teste1'
                        hidden={process.env.NODE_ENV === 'production'}
                        icon={<Icons icon={faCogs} />}
                      >
                        <span>Teste</span>
                        <Link to={`${APP_PREFIX_PATH}/teste`} />
                      </Menu.Item>

                      <Menu.Item
                        onClick={responsive ? toggle : null}
                        key='Sair'
                        icon={<Icons icon={faPowerOff} />}
                      >
                        <span>Sair</span>
                        <Link to={`${APP_PREFIX_PATH}/logout`} />
                      </Menu.Item>
                    </>
                  ) : null}
                  <Menu.Item style={{ pointerEvents: 'none' }}>{'  '}</Menu.Item>
                  <div
                    className='version-list'
                    hidden={responsive}
                    // onClick={() => setVersionDrawer(true)}
                  >
                    <span>v{process.env.REACT_APP_VERSION}</span>
                  </div>
                </Menu>
              )}
            </Sider>
          </div>
          <Layout className='site-layout' style={{ overflow: 'hidden' }}>
            <Header
              style={{ height: '76px', padding: '0', margin: '0' }}
              hidden={responsive}
              className='site-layout-background'
            >
              <div
                style={{
                  height: '76px',
                  display: 'flex',
                  justifyContent: 'left',
                  alignItems: 'center',
                  paddingRight: '15px',
                }}
              >
                {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                  className: 'trigger',
                  onClick: toggle,
                })}
                {!responsive && selectClient}
                <div hidden={responsive} className='option-user'>
                  <a
                    style={{
                      marginTop: '8px',
                      marginRight: '15px',
                    }}
                    href='#'
                  >
                    <Popover trigger='click' content={<>Sem notificações</>}>
                      <Badge size='default' count={0}>
                        <span
                          style={{
                            fontSize: '20px',
                            textDecoration: 'none',
                            color: '#7b7b7b',
                          }}
                        >
                          <BellOutlined />
                        </span>
                      </Badge>
                    </Popover>
                  </a>
                  <DropUser />
                </div>
              </div>
            </Header>
            <Content style={{ marginTop: responsive && '30px', minHeight: 'calc(100vh - 76px)' }}>
              <AppViews />
            </Content>
          </Layout>
        </Layout>
      )}
      <Drawer
        size='large'
        closeIcon={false}
        open={versionDrawer}
        onClose={() => setVersionDrawer(false)}
      >
        <Timeline>
          {version.map((data) => (
            <Timeline.Item key={String(data.version)}>
              <h2>{data.version}</h2>
              <p>
                <code>{data.data}</code>
              </p>
              <ul>
                {data.log.map((log) => (
                  <li key={String(log.descricao)}>{log.descricao}</li>
                ))}
              </ul>
            </Timeline.Item>
          ))}
        </Timeline>
      </Drawer>
    </Container>
  )
}

export default memo(MenuLyout)
